import React from 'react';
import PdfDeck from '../PdfDeck';

function Garhmukhteshwar() {
  return <PdfDeck file='/machines-pdfs/mushroom_farm_garh_phase1.pdf' />;
}

export default Garhmukhteshwar;
